import { PutObjectCommand, S3Client } from '@aws-sdk/client-s3';
window.Buffer = window.Buffer || require("buffer").Buffer;

const S3_BUCKET = 'elogicbiometrics-qa-files';

const s3Client = new S3Client({
  region: 'us-east-1',
  credentials: {
    accessKeyId: 'AKIAVLCHWNVN4G43RXXG',
    secretAccessKey: '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',
  },
});

export async function uploadImageFromFile(file) {
  const ext = file.name.split('.').reverse()[0];
  const key = `photos/ebm_${new Date().getTime()}.${ext}`;
  const input = { Bucket: S3_BUCKET, Key: key, Body: file, ContentType: file.type };
  await s3Client.send(new PutObjectCommand(input));
  return key;
}

export async function uploadImageFromBase64(params, base64string) {
  const folder = params.phone ? 'facesRegistry' : 'photos';
  const key = `${folder}/${params.documentId}_${new Date().getTime()}.jpg`;
  const base64data = Buffer.from(base64string, 'base64');
  const input = { Bucket: S3_BUCKET, Key: key, Body: base64data, ContentType: 'image/jpeg', ContentEncoding: 'base64' };
  await s3Client.send(new PutObjectCommand(input));
  return key;
}
